const binding = { modules: {}, dataActions: {} };

    (binding.modules['britax-hover-module'] = {
        c: () => require('partner/modules/britax-hover-module/britax-hover-module.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'britax-hover-module',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/britax-hover-module'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|britax-hover-module|britax-hover-module'] = {
                c: () => require('partner/modules/britax-hover-module/britax-hover-module.view.tsx'),
                cn: '__local__-__local__-britax-hover-module'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };